
'use strict'

class Validate {
    
    constructor(){
        this.error = '';
    }

    validate (value) {}

    getError () {
        return this.error;
    }

}

export default Validate;
